<script setup lang="ts">
const authStore = useAuthStore();
const router = useRouter();

const isAdmin = await authStore.isAdmin();
if (!isAdmin) {
  router.push('/');
}
</script>

<template>
  <!DOCTYPE html>
  <Html lang="en">
    <Head>
      <Title>Rapid Sequence</Title>
    </Head>
  </Html>

  <Body>
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <div id="site-wrapper">
      <div id="main" class="flex flex-col font-afacad">
        <HeaderBlock />
        <div class="p-8 flex flex-col flex-auto">
          <div
            class="border-2 border-surface rounded-border bg-surface-0 flex-auto container xl mx-auto"
          >
            <div class="h-full mx-auto p-8 bg-slate-200">
              <slot v-if="authStore.isAuthenticated" />
              <div v-else>You are not authenticated.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Body>
</template>

<style>
body .p-splitbutton-button {
  display: none;
}

body .p-splitbutton-dropdown {
  border-radius: 6px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
